import { BBPS_CONSTANTS as types, ORDERS as orderTypes } from '@store/constants';

const initialState = {
  categories: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    isUpdating: false
  },
  bbpsComplaints: {
    isLoading: false,
    isError: false,
    error: null,
    data: [],
    isCreating: false,
    isUpdating: false,
    currentOrderId: '',
    searchOrderId: ''
  }
};

const bbpsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    // Complaints (handled under ORDERS constants)
    case orderTypes.GETTING_BBPS_COMPLAINTS:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isLoading: true,
          isError: false,
          error: null
        }
      };

    case orderTypes.GET_BBPS_COMPLAINTS_SUCCESS:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isLoading: false,
          isError: false,
          error: null,
          data: payload || []
        }
      };

    case orderTypes.GET_BBPS_COMPLAINTS_FAILURE:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isLoading: false,
          isError: true,
          error: payload,
          data: []
        }
      };

    case orderTypes.CREATING_BBPS_COMPLAINT:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isCreating: true
        }
      };

    case orderTypes.CREATE_BBPS_COMPLAINT_SUCCESS:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isCreating: false,
          data: [payload, ...state.bbpsComplaints.data]
        }
      };

    case orderTypes.CREATE_BBPS_COMPLAINT_FAILURE:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isCreating: false
        }
      };

    case orderTypes.UPDATING_BBPS_COMPLAINT:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isUpdating: true
        }
      };

    case orderTypes.UPDATE_BBPS_COMPLAINT_SUCCESS:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isUpdating: false,
          data: state.bbpsComplaints.data.map(complaint =>
            complaint.complaintId === payload.complaintId ? payload : complaint
          )
        }
      };

    case orderTypes.UPDATE_BBPS_COMPLAINT_FAILURE:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          isUpdating: false
        }
      };

    case orderTypes.SET_BBPS_SEARCH_ORDER_ID:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          searchOrderId: payload
        }
      };

    case orderTypes.SET_BBPS_CURRENT_ORDER_ID:
      return {
        ...state,
        bbpsComplaints: {
          ...state.bbpsComplaints,
          currentOrderId: payload
        }
      };

    case orderTypes.CLEAR_BBPS_COMPLAINTS:
      return {
        ...state,
        bbpsComplaints: {
          isLoading: false,
          isError: false,
          error: null,
          data: [],
          isCreating: false,
          isUpdating: false,
          currentOrderId: '',
          searchOrderId: ''
        }
      };

    case types.GETTING_BBPS_CATEGORIES:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: true,
          isError: false,
          error: null
        }
      };

    case types.GET_BBPS_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: false,
          isError: false,
          error: null,
          data: payload || []
        }
      };

    case types.GET_BBPS_CATEGORIES_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: false,
          isError: true,
          error: payload,
          data: []
        }
      };

    case types.UPDATING_BBPS_CATEGORY:
      return {
        ...state,
        categories: {
          ...state.categories,
          isUpdating: true,
          isError: false,
          error: null
        }
      };

    case types.UPDATE_BBPS_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          isUpdating: false,
          isError: false,
          error: null,
          data: state.categories.data.map(category => 
            category.categoryId === payload.categoryId ? payload : category
          )
        }
      };

    case types.UPDATE_BBPS_CATEGORY_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          isUpdating: false,
          isError: true,
          error: payload
        }
      };

    case types.DELETING_BBPS_CATEGORY:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: true,
          isError: false,
          error: null
        }
      };

    case types.DELETE_BBPS_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: false,
          isError: false,
          error: null,
          data: state.categories.data.filter(category => 
            category.categoryId !== payload.categoryId
          )
        }
      };

    case types.DELETE_BBPS_CATEGORY_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          isLoading: false,
          isError: true,
          error: payload
        }
      };

    case types.CLEAR_BBPS_CATEGORIES:
      return {
        ...state,
        categories: {
          isLoading: false,
          isError: false,
          error: null,
          data: []
        }
      };


    default:
      return state;
  }
};

export default bbpsReducer;
